import {LOADING_END, LOADING_START} from "./actionTypes";

export const stopLoading = () => ({
  type: LOADING_END
});

export const startLoading = () => ({
  type: LOADING_START
});
